import React from 'react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css/autoplay';
import styled from 'styled-components';
import { breakpointSizes, minBreakpointQuery, sectionMargins } from '../styles';
import { Slider } from './ui';

const StyledFeaturedLogos = styled.section`
  ${sectionMargins('75px')};
`;

const StyledItems = styled(Slider)`
  padding: 0 30px;

  .swiper-wrapper {
    align-items: center;
  }

  .swiper-slide {
    text-align: center;
  }
`;

const StyledItem = styled.img`
  height: 100%;
  width: 100%;
  max-height: 50px;
  max-width: 150px;

  ${minBreakpointQuery.small`
    max-height: 60px;
    max-width: 180px;
  `}

  ${minBreakpointQuery.large`
    max-height: 70px;
    max-width: 210px;
  `}
`;

const FeaturedLogos = ({ items: initialItems }) => {
  const sliderOptions = {
    modules: [Autoplay],
    slidesPerView: 2,
    spaceBetween: 30,
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      [breakpointSizes.tiny]: { slidesPerView: 3 },
      [breakpointSizes.medium]: { slidesPerView: 4 },
      [breakpointSizes.xxlarge]: { slidesPerView: 5 },
      [breakpointSizes.xxxxlarge]: { slidesPerView: 6 },
    },
  };

  const items = initialItems.filter(
    ({ mimeType }) => mimeType === 'image/svg+xml',
  );

  return (
    items.length > 0 && (
      <StyledFeaturedLogos>
        <StyledItems {...sliderOptions}>
          {items.map(({ url, title }, id) => (
            <StyledItem key={id} src={url} alt={title} loading="lazy" />
          ))}
        </StyledItems>
      </StyledFeaturedLogos>
    )
  );
};

export default FeaturedLogos;
